var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-box-corner",class:'info-box-corner-' + _vm.color},[_c('div',[_vm._v(_vm._s(_vm.discountFrom)+" % - "+_vm._s(_vm.discountTo)+" %")])])}
var staticRenderFns = []

export { render, staticRenderFns }